import styled from '@emotion/styled';
import { CardImage } from 'components/common/ui/CardImage';
import ProductColorPicker from 'cards/components/common/ProductColorPicker/ProductColorPicker';

export const Tile = styled.div`
  position: relative;
`;

export const StyledCardImage = styled(CardImage)`
  display: block;
  border-radius: 4px;
  width: 100%;
`;

export const FavoriteToggleWrapper = styled.div`
  position: absolute;
  right: 10px;
  top: 10px;
`;

interface ColorPickerProps {
  hideColorPickerInMobile?: boolean;
}

export const StyledProductColorPicker = styled(ProductColorPicker)<ColorPickerProps>`
  padding-left: 12px;
  display: ${props => (props.hideColorPickerInMobile ? 'none' : 'block')};

  ${props => props.theme.MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    display: block;
  }
`;

export const SuitePrice = styled.div`
  padding-left: 12px;
  margin-top: 20px;

  ${props => props.theme.MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    margin-top: 24px;
  }
`;

export const SuiteColors = styled.div`
  padding-left: 12px;
  color: ${props => props.theme.COLORS_NEUTRALS.BLACK_100};
  opacity: 0.6;

  ${props => props.theme.MEDIA_QUERY.EXCLUDE_MOBILE_XS} {
    display: none;
  }
`;

export const SuiteImage = styled.div`
  padding: 0;
`;
